import type { ProjectDto } from '../api/client';

/** Projects as an indented tree (subprojects under their parent), legacy print_project_option_list. */
export function projectOptions(projects: ProjectDto[], includeAll = true) {
  const byId = new Map(projects.map((p) => [p.id, p]));
  const children = new Set(projects.flatMap((p) => p.subprojectIds));
  const out: { value: string; label: string }[] = [
    includeAll
      ? { value: '0', label: 'All projects' }
      : { value: '0', label: '(choose a project)' },
  ];
  const walk = (p: ProjectDto, depth: number, seen: Set<number>) => {
    if (seen.has(p.id)) return;
    seen.add(p.id);
    out.push({ value: String(p.id), label: `${'» '.repeat(depth)}${p.name}` });
    for (const c of p.subprojectIds) {
      const child = byId.get(c);
      if (child) walk(child, depth + 1, seen);
    }
  };
  const seen = new Set<number>();
  for (const p of projects
    .filter((x) => !children.has(x.id))
    .sort((a, b) => a.name.localeCompare(b.name)))
    walk(p, 0, seen);
  for (const p of projects) if (!seen.has(p.id)) walk(p, 0, seen); // cycles / orphans
  return out;
}
